/* eslint-disable indent */
export default {
    token: (state) => state.token,
    user: (state) => state.user,
    prizesCodes: (state) => state.prizesCodes,
};
